"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M3 1v7H1a1 1 0 00-1 1v10a1 1 0 001 1h13a1 1 0 001-1v-4h4a1 1 0 001-1V3c0-.55-.45-1-1-1h-7.58L9.71.3A.966.966 0 009 0H4c-.55 0-1 .45-1 1zm7.596 3H18v9h-3V9a1 1 0 00-1-1H5V2h3.584l2.012 2zM9 10h2l-5 8H4l5-8z"];
//# sourceMappingURL=root-folder.js.map